// extracted by css-extract-rspack-plugin
export default {"faqs-wrapper":"Faqs-module__faqs-wrapper--Gj6GS","accordion-head":"Faqs-module__accordion-head--IuTuS"};